import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { ProgressbarComponent } from './progressbar.component';
import { ProgressbarRoutingModule } from './progressbar.routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ProgressbarRoutingModule,
  ],
  exports: [
    ProgressbarComponent
  ],
  declarations: [
    ProgressbarComponent
  ],
})
export class ProgressbarModule { }
